import { AppHeaderDropdown } from '@coreui/react'
import {
  Alert,
  Badge,
  Button,
  Card,
  CardBody,
  CardLink,
  CardText,
  CardTitle,
  DropdownMenu,
  DropdownToggle,
  UncontrolledTooltip
} from 'reactstrap'
import React from 'react'
import { FormatDateNoSeconds } from '../../services/Functions'

export const Notifications = ({ notifications, onReadAll, onRead }) => {
  return notifications != null ? (
    <AppHeaderDropdown direction="down">
      <DropdownToggle
        nav
        style={{
          marginLeft: '10px',
          borderRight: '1px solid grey',
          paddingRight: '10px',
          cursor: 'pointer'
        }}
      >
        <img src="/notifications.svg" alt="Notifications" style={{ width: 25 }} />
        {notifications.length !== 0 ? <Badge color="primary">{notifications.length}</Badge> : null}
      </DropdownToggle>
      <DropdownMenu
        right
        style={{
          right: 'auto',
          width: 300,
          maxHeight: notifications.length !== 0 ? 200 : 50,
          overflowY: notifications.length >= 2 ? 'scroll' : 'auto'
        }}
      >
        {notifications.length === 0 ? (
          <Alert color="danger" className="rounded-0 m-0 h-100 text-center">
            No hay nuevas notificaciones
          </Alert>
        ) : (
          <React.Fragment>
            <Card className="sticky-top rounded-0 m-0">
              <CardBody className="pt-2 pb-2 pr-1 pl-1 text-center">
                <CardLink
                  href="#"
                  className="small mb-1"
                  onClick={(e) => {
                    e.preventDefault()
                    onReadAll()
                  }}
                >
                  Marcar todas como leídas
                </CardLink>
              </CardBody>
            </Card>
            {notifications.map((n) => (
              <Card key={n.id} className="rounded-0 m-0">
                <CardBody className="pt-2 pb-2 pr-1 pl-1">
                  <div className="small text-secondary mb-1">{FormatDateNoSeconds(n.date)}</div>
                  <CardTitle className="mb-1">{n.title}</CardTitle>
                  <CardText className="small mb-1">{n.body}</CardText>
                  <UncontrolledTooltip placement="left" target={`notification-${n.id}`}>
                    Marcar notificación como leída
                  </UncontrolledTooltip>
                  <Button
                    id={`notification-${n.id}`}
                    className="btn btn-sm btn-conway float-right mr-1"
                    onClick={() => onRead(n.id)}
                  >
                    <i className="fa fa-check" />
                  </Button>
                </CardBody>
              </Card>
            ))}
          </React.Fragment>
        )}
      </DropdownMenu>
    </AppHeaderDropdown>
  ) : null
}
